import { useCallback, useEffect, useRef, useState } from "react";
import { CashCoveragePeriodThunk } from "../../../../../redux/features/Settings/Statistics";
import { useDispatch, useSelector } from "react-redux";
import formatTotalBalance from "../../../../../utils/formatTotalBalance";
import FecthingPage from "../../CommonComponents/FecthingPage";
import GraphHeader from "../../CommonComponents/GraphHeader";
import CommonToast from "../../../../_utils/CommonToast";
import ICONS from "../../../../../assets/Icons";

const CashCoveragePeriod = () => {
  const dummyDayWiseEntries = [
    { day: "01", amount: 12000 },
    { day: "02", amount: 25000 },
    { day: "03", amount: 18000 },
    { day: "04", amount: 22000 },
    { day: "05", amount: 30000 },
    { day: "06", amount: 27000 },
    { day: "07", amount: 15000 },
  ];
  const defaultGraphData = {
    dayWiseEntries: dummyDayWiseEntries, // array of { day, amount }
    dayWiseTotalDebitAmount: 10000,
    totalDebitAmount: 9000000,
    predictedCashPeriod: 3,
    totalCurrentBalance: 9000000,
  };
  const [graphData, setGraphData] = useState(defaultGraphData);
  const [fetchPageEnabled, setFetchPageEnabled] = useState(true);
  const [isError, setIsError] = useState(false);
  const toastShownRef = useRef(false);
  const [fetchPageLoading, setFetchPagefetchPageLoading] = useState(false);

  const dispatch = useDispatch();
  const loginData = useSelector((state) => state.refreshToken.data);

  const { CashCoveragePeriodThunkLoading, CashCoveragePeriodThunkError } =
    useSelector((state) => state.settingStatistics);
  const entityId = loginData?.status ? loginData?.entity?.entity_id : "";

  const handleCalculation = useCallback(
    async (response) => {
      const reportData = response?.payload?.report_data;

      if (response?.payload?.status && reportData) {
        setGraphData({
          dayWiseEntries: reportData.day_wise_entries, // array of { day, amount }
          dayWiseTotalDebitAmount: reportData.day_wise_total_debit_amount,
          totalDebitAmount: reportData.total_debit_amount,
          predictedCashPeriod: reportData.predicted_cash_period,
          totalCurrentBalance: reportData.total_current_balance,
        });
        // toast shows only once
        if (!toastShownRef.current && fetchPageEnabled) {
          CommonToast({
            text: "Fetched successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
          toastShownRef.current = true;
        }
        setFetchPageEnabled(false);
        setIsError(false);
      } else {
        // fallback to defaults
        setGraphData(defaultGraphData);
        setFetchPageEnabled(response?.payload?.status !== 404);
        toastShownRef.current = false;

        setIsError(true);
      }
    },
    [dispatch, entityId],
  );

  const fetchData = async () => {
    const response = await dispatch(
      CashCoveragePeriodThunk({ entity_id: entityId }),
    );

    setFetchPagefetchPageLoading(false);
    handleCalculation(response);
  };

  useEffect(() => {
    if (!fetchPageEnabled) {
      fetchData();
    }
  }, [fetchPageEnabled]);

  const handleFetchClick = () => {
    setFetchPagefetchPageLoading(true);
    setFetchPageEnabled(false);
  };

  return (
    <div className="w-width-full flex flex-col bg-primary-card rounded-border-radius-md">
      <GraphHeader
        handlingOptionsRequired={[]}
        titleText={"Cash coverage period"}
      />
      <div className="flex flex-col relative">
        <FecthingPage
          fetchPageEnabled={fetchPageEnabled}
          loading={CashCoveragePeriodThunkLoading || fetchPageLoading}
          isError={isError}
          errorData={CashCoveragePeriodThunkError}
          handleFunction={handleFetchClick}
        />

        <div className="w-width-full flex Qsmd:flex-row flex-col">
          <div className="Qsmd:w-auto w-width-full h-auto flex flex-col bg-primary-nav-act justify-center items-center flex-shrink-0 overflow-y-auto Qsmd:rounded-bl-border-radius-md">
            <div className="w-width-full px-padding-md pt-padding-md flex flex-col h-[var(--statistic-graph-height)]">
              <div className="text-text-secondary text-font-xxs font-semibold mb-margin-md">
                Amount debited day wise
              </div>
              <div className="flex flex-col gap-gap-sm w-width-full h-height-full pb-padding-sm border-b-border border-b-primary-bg">
                {graphData?.dayWiseEntries?.map((val, index) => {
                  return (
                    <div className="flex justify-between">
                      <div className="text-text-secondary text-font-xxs">
                        {val?.day}
                      </div>
                      <div className="text-text-secondary text-font-xxs font-semibold">
                        {fetchPageEnabled
                          ? "-"
                          : "INR " +
                            formatTotalBalance(val?.amount, "amount").amount}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="w-width-full h-auto flex justify-between mt-margin-sm mb-margin-md px-padding-md">
              <div className="text-text-secondary text-font-xxs">Total</div>
              <div className="text-text-secondary text-font-xxs font-semibold">
                {fetchPageEnabled
                  ? "-"
                  : "INR " +
                    formatTotalBalance(
                      graphData?.dayWiseTotalDebitAmount,
                      "amount",
                    ).amount}
              </div>
            </div>
          </div>
          <div className="w-width-full p-padding-md">
            <div className="flex flex-col gap-gap-lg Qmd:gap-gap-base justify-between h-height-full">
              <div className="flex flex-col gap-gap-lg h-height-full">
                <div className="flex justify-between items-center">
                  <div className="flex flex-col gap-gap-xs">
                    <div className="text-text-primary font-sans text-font-xs">
                      Total current balance
                    </div>
                    <div className="text-text-secondary font-sans text-font-xxs">
                      across all owner accounts
                    </div>
                  </div>
                  <div className="text-settled font-sans text-font-sm font-semibold">
                    {fetchPageEnabled
                      ? "-"
                      : "INR " +
                        formatTotalBalance(
                          graphData.totalCurrentBalance,
                          "amount",
                        ).amount}
                  </div>
                </div>
                <div className="flex justify-center">
                  <img
                    className="w-icon-sm h-icon-sm"
                    src="https://q2pay.in/new_assets/common/settings/divide_white.svg"
                    alt="divide_white"
                  />
                </div>
                <div className="flex justify-between items-center">
                  <div className="flex flex-col gap-gap-xs">
                    <div className="text-text-primary font-sans text-font-xs">
                      Total debited amount
                    </div>
                    <div className="text-text-secondary font-sans text-font-xxs">
                      across all owner accounts last week
                    </div>
                  </div>
                  <div className="text-negative-act font-sans text-font-sm font-semibold">
                    {fetchPageEnabled
                      ? "-"
                      : "INR " +
                        formatTotalBalance(graphData.totalDebitAmount, "amount")
                          .amount}
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-gap-lg">
                <div className="border-t border-primary-bg"></div>
                <div className="flex flex-col gap-gap-lg justify-between items-center relative">
                  <div
                    className="grid w-width-full justify-between items-center"
                    style={{ gridTemplateColumns: "1fr 0.5fr 1fr" }}
                  >
                    <div className="flex flex-col gap-gap-xs">
                      <div className="text-text-primary font-sans text-font-xs">
                        Predicted cash coverage period
                      </div>

                      <div className="text-text-secondary font-sans text-font-xxs">
                        in weeks
                      </div>
                    </div>
                    <div className="flex justify-self-center items-center relative inset-x-0 mx-auto">
                      <img
                        className="w-icon-sm h-icon-sm"
                        src="https://q2pay.in/new_assets/common/settings/equals_with_roundness.svg"
                        alt="equals_to_linear_white"
                      />
                    </div>
                    <div className="text-text-secondary font-sans text-font-sm font-semibold text-right">
                      {fetchPageEnabled ? "-" : graphData?.predictedCashPeriod}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CashCoveragePeriod;
